import React from "react";
import { Outlet } from "react-router-dom";

import Footer from "../footer/Footer";
import ProductCartDetailsTopBar from "../navigator/ProductCartDetailsTopBar";

const DetailsPage = () => {
  return (
    <div>
      <ProductCartDetailsTopBar />
      <div>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default DetailsPage;
